import React, { useEffect, useState } from "react";
import Pusher from "pusher-js";
import { useRouter } from "next/router";
import {
  useCountdown,
  getAllBids_AuctionFloor,
  getAllWrongBids_AuctionFloor,
  getLatestBidOfUser_AuctionFloor,
  getLatestBid_AuctionFloor,
  getAuctionEventByUuid_AuctionFloor,
  getBidderByUserUuidAndEventUuid_AuctionFloor,
  getAuctionEventStatusById_AuctionFloor,
} from "services";
import { ModalBase, ButtonBase } from "@reusejs/react";
import { DateTime } from "luxon";
import EventData from "./eventData";
import CorrectBids from "./correctBids";
import StickyFooter from "./stickyFooter";
import { useSelector } from "react-redux";
import BidsResultModal from "./bidsResultModal";
import useInternetSpeed from "../../hoc/useInternetSpeed";
import { RefreshIcon } from "@heroicons/react/outline";

// interface ExtendedNavigator extends Navigator {
//   connection?: {
//     downlink: number;
//   };
// }

export default function AuctionFloor(props: any) {
  const [reservePrice, setReservePrice] = useState(0);
  const [amount, setAmount] = useState(0);
  const [biddingAmount, setBiddingAmount] = useState(0);
  const [endTime, setEndTime] = useState(0);
  const [startTime, setStartTime] = useState(0);
  const [status, setStatus] = useState("");
  const [currentTime, setCurrentTime] = useState<any>(0);
  const [bidsEvent, setBidsEvent] = useState<any[]>([]);
  const [latestBid, setLatestBid] = useState<any>(null);
  const [prevBid, setPrevBid] = useState<any>(null);
  const [currentUserLatestBid, setCurrentUserLatestBid] = useState<any>(null);
  const [wrongBidsEvent, setWrongBidsEvent] = useState<any[]>([]);
  const [showSuccessNotification, setShowSuccessNotification] =
    useState<Boolean>(false);
  const [showFailedNotification, setShowFailedNotification] =
    useState<Boolean>(false);
  const [failedNotification, setFailedNotification] = useState<any>(null);
  const [loading, setLoading] = useState<any>(true);
  const [biddingType, setBidddingType] = useState<any>("ib");
  const [connectionStatus, setConnectionStatus] = useState<any>("Offline");
  const [isTimeEnded, setIsTimeEnded] = useState<number>(0);
  const [flag, setFlag] = useState<Boolean>(false);
  const [serverTime, setServerTime] = useState(0);
  const [timeOffset, setTimeOffset] = useState(0);

  const checkBidStatus = async (checkStatus = 0) => {
    console.log("checkBidStatus func called!", isTimeEnded, checkStatus);
    if (isTimeEnded || checkStatus) {
      try {
        setFlag(true);
        setTimeout(async () => {
          const res: any = await getAuctionEventStatusById_AuctionFloor(id);
          console.log("result--->time", res);
          if (res?.status && res?.status === "end") {
            setStatus(res?.status);
            handleBidsResult();
          }
        }, 1000);
        setFlag(false);
      } catch (error) {
        setFlag(false);
        console.log("error", error);
      }
    }
  };

  const {
    query: { id },
  } = useRouter();

  const router = useRouter();
  const { isOnline, isOnlineEventTriggered } = useInternetSpeed();

  const user = useSelector((state: any) => {
    return state.bidderAuth.user;
  });

  useEffect(() => {
    (async () => {
      if (user) {
        const data: any = await getBidderByUserUuidAndEventUuid_AuctionFloor(
          user.uuid,
          id,
          "verified"
        );
        if (data.length === 0) {
          router.push("/auction-events");
        }
      }
    })();
  }, [user, id]);

  // fetch bids data
  const init = async (uuid: any) => {
    console.log("init function started");
    setLoading(true);
    try {
      const data: any = await getAuctionEventByUuid_AuctionFloor(uuid);
      if (data) {
        setServerTime(data.server_time);
        const allBid: any = await getAllBids_AuctionFloor(data.uuid);
        const allWrongBids: any = await getAllWrongBids_AuctionFloor(
          data.uuid,
          user.uuid
        );
        const currentUserLastBid: any = await getLatestBidOfUser_AuctionFloor(
          data.uuid,
          user.uuid
        );
        setCurrentUserLatestBid(currentUserLastBid);
        if (allBid) {
          setBidsEvent(allBid);
          if (allBid.length >= 2) {
            setPrevBid(allBid[allBid.length - 2]);
          }
        }
        if (allWrongBids) {
          setWrongBidsEvent(allWrongBids);
        }
        const lastBid: any = await getLatestBid_AuctionFloor(data.uuid);
        setLatestBid(lastBid);
        setReservePrice(data.reserve_price);
        setStatus(data.status);
        const start_timestamp = DateTime.fromISO(data.start_date_time)
          .setZone("Asia/Kolkata")
          .toMillis();
        setStartTime(start_timestamp);

        if (lastBid) {
          setAmount(lastBid.final_amount);
          setBiddingAmount(lastBid.final_amount);
          setEndTime(parseInt(lastBid.final_end_time));
        } else {
          setAmount(parseInt(data.reserve_price));
          setBiddingAmount(parseInt(data.reserve_price));
          setEndTime(parseInt(data.final_end_date));
        }
        setBidddingType(data.bidding_type);
        setLoading(false);
      }
    } catch (err) {
      console.log("error in init::>", err);
      // setLoading(false);
      router.reload();
    }
  };

  // pusher functionality
  useEffect(() => {
    // Pusher.logToConsole = false;
    const pusher = new Pusher(`${process.env.NEXT_PUBLIC_PUSHER_KEY}`, {
      cluster: process.env.NEXT_PUBLIC_PUSHER_CLUSTER,
    });

    const channelId = `auction-event-${id}`;
    console.log("channelId: ", channelId);
    const channel = pusher.subscribe(channelId);

    channel.bind("bidding_value_has_been_changed", (data: any) => {
      handleDataChange(data);
      setBidsEvent((prev) => [...prev, data]);
      // setBidsEvent([...bidsEvent, data]);
    });

    channel.bind("user_placed_wrong_bid", (data: any) => {
      if (data.user_uuid === user.uuid) {
        setServerTime(data.server_time);
        setWrongBidsEvent((prev) => [...prev, data]);
        setFailedNotification(null);
        setShowFailedNotification(false);
        setShowSuccessNotification(false);
        setFailedNotification(data.reason);
        setShowFailedNotification(true);
        (async () => {
          await checkBidStatus();
        })();
      }
    });

    channel.bind("auction_event_has_started", (data: any) => {
      if (data) {
        setServerTime(data.server_time);
        setStatus("live");
      }
    });

    channel.bind("auction_event_has_ended", (data: any) => {
      console.log("auction_event_has_ended----", data);

      if (data) {
        setStatus("end");
        handleBidsResult();
      }
    });

    pusher.connection.bind("error", function (err: any) {
      console.log("PUSHER ERROR:::>", err);
      if (err?.error?.data?.code === 4004) {
        console.log(">>> detected limit error");
      } else if (err?.data?.code === 1006) {
        console.log(">>> CLOSED ABNORMALLY");
        // Websocket: CLOSED ABNORMALLY
        // get the data and refresh the page if fails
        init(id);
      }
    });

    pusher.connection.bind("disconnected", function (err: any) {
      console.log(">>> disconnected");
      setConnectionStatus("Offline");
    });

    pusher.connection.bind("connected", function (err: any) {
      console.log("connected", pusher.sessionID);
      setConnectionStatus("Online");
    });

    pusher.connection.bind("state_change", (states: any) => {
      const { current, previous } = states;
      console.log(`current state: ${current}, previous state: ${previous}`);
      switch (current) {
        case "failed":
          setConnectionStatus("Offline");
          break;
        case "disconnected":
          setConnectionStatus("Offline");
          break;
        case "unavailable":
          setConnectionStatus("Offline");
          break;
        case "connected":
          setConnectionStatus("Online");
          break;
        case "connecting":
          setConnectionStatus("Connecting"); // Connecting
          break;
        default:
          break;
      }
    });

    return function cleanup() {
      pusher.disconnect();
    };
  }, [id]);

  // if auction is ongoing and somebody came in between then fetch data from latest bid
  useEffect(() => {
    if (props.data) {
      init(props.data.uuid);
    }
  }, [props.data]);

  // get the timeoffset
  useEffect(() => {
    if (serverTime) {
      const serverDateTime =
        DateTime.fromMillis(serverTime).setZone("Asia/Kolkata");
      const localDateTime = DateTime.now().setZone("Asia/Kolkata");
      const offset = serverDateTime.toMillis() - localDateTime.toMillis();
      setTimeOffset(offset);
    }
  }, [serverTime]);

  // current time
  useEffect(() => {
    console.log("Update time");
    const intervalId = setInterval(() => {
      setCurrentTime(
        DateTime.now()
          .plus({ milliseconds: timeOffset })
          .setZone("Asia/Kolkata")
          .toFormat("hh:mm:ss a")
      );
    }, 1000);
    return () => clearInterval(intervalId);
  }, [timeOffset]);

  useEffect(() => {
    console.log("isOnline::>", isOnline);
    if (!isOnline) {
      setConnectionStatus("Offline");
    } else {
      setConnectionStatus("Online");
    }
  }, [isOnline]);

  useEffect(() => {
    if (isOnlineEventTriggered) {
      router.reload();
    }
  }, [isOnlineEventTriggered]);

  const handleDataChange = async (data: any) => {
    // send the server time from the lambda as well
    console.log("data.server_time::::>", data.server_time);
    setServerTime(data.server_time);
    setAmount(data.final_amount);
    setEndTime(data.final_end_time);
    if (latestBid) {
      setPrevBid(latestBid);
    }
    const lastBid: any = await getLatestBid_AuctionFloor(data.event_uuid);

    setLatestBid((prev: any) => {
      setPrevBid(prev);
      return lastBid;
    });

    const currentUserLastBid: any = await getLatestBidOfUser_AuctionFloor(
      data.event_uuid,
      user.uuid
    );
    setCurrentUserLatestBid(currentUserLastBid);
    if (user.uuid === data.user_uuid) {
      setFailedNotification(null);
      setShowFailedNotification(false);
      setShowSuccessNotification(true);
    }
  };

  const openModal = async (title: string, message: string, color: string) => {
    const BidsResultModalWrapper = (props: any) => {
      return (
        <BidsResultModal
          heading={title}
          description={message}
          color={color}
          {...props}
        />
      );
    };

    await ModalBase(
      {
        content: BidsResultModalWrapper,
        timeout: 0,
        backgroundColor: "bg-black/30",
        backgroundOpacity: "opacity-70",
        modalBaseClasses: {
          background: "bg-white",
          border: "border-2 rounded-lg",
          alignment: "text-left overflow-visible",
          padding: "p-0",
          small: "sm:my-8 sm:w-full sm:max-w-md",
        },
      },
      1000,
      "__next"
    );
  };

  const handleBidsResult = async () => {
    openModal("Auction has ended!", "", "bg-green-50 text-green-500");
  };

  useEffect(() => {
    setTimeout(() => {
      setShowSuccessNotification(false);
      setFailedNotification(null);
      setShowFailedNotification(false);
    }, 5000);
  }, [showSuccessNotification, showFailedNotification]);

  return (
    <>
      {showSuccessNotification && (
        <div
          className="fixed top-4 right-0 sm:right-4 z-50 bg-teal-100 rounded-md text-teal-900 px-4 py-3 shadow-lg"
          role="alert"
        >
          <div className="flex">
            <div className="py-1">
              <svg
                className="fill-current h-6 w-6 text-teal-500 mr-4"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
              >
                <path d="M2.93 17.07A10 10 0 1 1 17.07 2.93 10 10 0 0 1 2.93 17.07zm12.73-1.41A8 8 0 1 0 4.34 4.34a8 8 0 0 0 11.32 11.32zM9 11V9h2v6H9v-4zm0-6h2v2H9V5z" />
              </svg>
            </div>
            <div>
              <p className="font-bold">Success</p>
              <p className="text-sm">
                You have submitted the bid successfully.
              </p>
            </div>
          </div>
        </div>
      )}
      {showFailedNotification && (
        <div
          className="fixed top-4 right-0 sm:right-4 z-50 bg-red-100 rounded-md text-red-900 px-4 py-3 shadow-lg"
          role="alert"
        >
          <div className="flex">
            <div className="py-1">
              <svg
                className="fill-current h-6 w-6 text-red-500 mr-4"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
              >
                <path d="M2.93 17.07A10 10 0 1 1 17.07 2.93 10 10 0 0 1 2.93 17.07zm12.73-1.41A8 8 0 1 0 4.34 4.34a8 8 0 0 0 11.32 11.32zM9 11V9h2v6H9v-4zm0-6h2v2H9V5z" />
              </svg>
            </div>
            <div>
              <p className="font-bold">Failure</p>
              <p className="text-sm">Reason: {failedNotification}</p>
            </div>
          </div>
        </div>
      )}
      <div className="flex justify-end">
        <ButtonBase
          variant="primary"
          type="submit"
          label="Refresh"
          onClick={() => router.reload()}
          buttonPrefix={
            <RefreshIcon
              height="16"
              width="16"
              className="rotate-180 mr-1 sm:mr-2"
            />
          }
          buttonBaseClasses={{
            font: "text-xs sm:text-sm font-medium",
            backgroundColor: "bg-blue-600 hover:bg-blue-700",
            textColor: "text-white",
            border: "any",
            width: "sm:w-24",
            padding: "px-2 py-2",
          }}
        />
      </div>
      <div className="rounded-lg">
        <StickyFooter
          amount={amount}
          id={id}
          status={status}
          reservePrice={reservePrice}
          latestBid={latestBid}
          biddingType={biddingType}
          connectionStatus={connectionStatus}
          isTimeEnded={isTimeEnded}
        />

        <div className="mb-8">
          {loading ? (
            <div
              role="status"
              className="py-4 space-y-4 border border-gray-200 divide-y divide-gray-200 rounded shadow animate-pulse dark:divide-gray-700 md:p-6 dark:border-gray-700"
            >
              <div className="flex items-center justify-between">
                <div>
                  <div className="h-2.5 bg-gray-300 rounded-full dark:bg-gray-600 w-24 mb-2.5"></div>
                  <div className="w-32 h-2 bg-gray-200 rounded-full dark:bg-gray-700"></div>
                </div>
                <div className="h-2.5 bg-gray-300 rounded-full dark:bg-gray-700 w-12"></div>
              </div>
              <div className="flex items-center justify-between pt-4">
                <div>
                  <div className="h-2.5 bg-gray-300 rounded-full dark:bg-gray-600 w-24 mb-2.5"></div>
                  <div className="w-32 h-2 bg-gray-200 rounded-full dark:bg-gray-700"></div>
                </div>
                <div className="h-2.5 bg-gray-300 rounded-full dark:bg-gray-700 w-12"></div>
              </div>
              <div className="flex items-center justify-between pt-4">
                <div>
                  <div className="h-2.5 bg-gray-300 rounded-full dark:bg-gray-600 w-24 mb-2.5"></div>
                  <div className="w-32 h-2 bg-gray-200 rounded-full dark:bg-gray-700"></div>
                </div>
                <div className="h-2.5 bg-gray-300 rounded-full dark:bg-gray-700 w-12"></div>
              </div>
              <div className="flex items-center justify-between pt-4">
                <div>
                  <div className="h-2.5 bg-gray-300 rounded-full dark:bg-gray-600 w-24 mb-2.5"></div>
                  <div className="w-32 h-2 bg-gray-200 rounded-full dark:bg-gray-700"></div>
                </div>
                <div className="h-2.5 bg-gray-300 rounded-full dark:bg-gray-700 w-12"></div>
              </div>
              <div className="flex items-center justify-between pt-4">
                <div>
                  <div className="h-2.5 bg-gray-300 rounded-full dark:bg-gray-600 w-24 mb-2.5"></div>
                  <div className="w-32 h-2 bg-gray-200 rounded-full dark:bg-gray-700"></div>
                </div>
                <div className="h-2.5 bg-gray-300 rounded-full dark:bg-gray-700 w-12"></div>
              </div>
              <span className="sr-only">Loading...</span>
            </div>
          ) : (
            <EventData
              data={props.data}
              latestBidAmount={amount}
              startTime={startTime}
              endTime={endTime}
              status={status}
              setStatus={setStatus}
              currentTime={currentTime}
              latestBid={latestBid}
              currentUserLatestBid={currentUserLatestBid}
              prevBid={prevBid}
              correctBids={bidsEvent}
              wrongBids={wrongBidsEvent}
              flag={flag}
              connectionStatus={connectionStatus}
              serverTime={serverTime}
              checkBidStatus={checkBidStatus}
              setIsTimeEnded={setIsTimeEnded}
              timeOffset={timeOffset}
            />
          )}
        </div>
      </div>
    </>
  );
}
